import gql from 'graphql-tag'

export const SEARCH_ORGANIZATION = gql`
    query Organizations($orgFilter: String!){
        Organizations(where: {_and:[{status:{_eq: "Active"}},{partnerType:{_in:["9260ebcf-8944-4dc1-a003-9997b0e07811","921a8e09-766f-4894-b04c-495059858bb4"]}}],_or: [{name: {_ilike: $orgFilter}},{mobile: {_ilike: $orgFilter}},{partnerCode: {_ilike: $orgFilter}}]}){
            name
            mobile
            id
            referralCode
            partnerCode
        }
    }`

export const SEARCH_ORGANIZATION_IN_STOCK_TRANSFER = gql`
    query Organizations($orgFilter: String!,$partnerType:[uuid!],$prefferedVP:uuid!){
        Organizations(where: {_and:[{status:{_eq: "Active"}},{partnerType:{_nin:$partnerType}},{PreferredDistributors: {prefferedDistributorId: {_eq: $prefferedVP}}}],_or: [{name: {_ilike: $orgFilter}},{mobile: {_ilike: $orgFilter}},{partnerCode: {_ilike: $orgFilter}}]}){
            name
            mobile
            id
            referralCode
            partnerCode
        }
    }`
export const SEARCH_ORGANIZATION_IN_STOCK_TRANSFER_WITH_DETAILS = gql`
    query Organizations($orgFilter: String!,$partnerType:[uuid!],$prefferedVP:uuid!){
        Organizations(where: {_and:[{status:{_eq: "Active"}},{partnerType:{_nin:$partnerType}},{PreferredDistributors: {prefferedDistributorId: {_eq: $prefferedVP}}}],_or: [{name: {_ilike: $orgFilter}},{mobile: {_ilike: $orgFilter}},{partnerCode: {_ilike: $orgFilter}}]}){
            id
            partnerType
            name
            mobile            
            referralCode
            partnerCode
            Users {id}
        }
    }`

export const GET_ALL_ORGANIZATION = gql`
    query ($partnerType:[uuid!],$prefferedVP:uuid!){
        Organizations(where:{status:{_eq: "Active"},partnerType:{_nin:$partnerType},
            PreferredDistributors: {prefferedDistributorId: {_eq: $prefferedVP}}}){
            id
            name
            Inventory: BatchTable_aggregate(where: {status:{_eq:"InStock"}}) {
                aggregate {
                    count
                }
            }
            Application{id userName incorporateDate userBirthdate userAniversary}
            Users {id name}
            partnerType
            PartnerType {id name color prefix specialSchemeId }
            SchemePoints {id earnPoint eligiblePoint myTeamEligiblePoint myTeamEarnPoint schemeId}
            PreferredDistributors (order_by: {PrefferedPartner: {name: asc}}) {id prefferedDistributorId PrefferedPartner{id name mobile email partnerCode}}
            partnerCode
            name
            status
            address
            mobile
            email
            gstin
            aadhaarNumber
            PAN
            bankDetails
            products
            partnerCode
            referralCode
            parentPartnerId
            createdOn
            SalesPersons (order_by: {SalesPerson: {name: asc}}) {id SalesPerson{name mobile email id}}
            ParentPartner{id name}
            PreferedVP{id name}
            lastLoggedIn
        }
    }
`
export const GET_COUNTS = gql`
    query($ownedBy:uuid){
        Product: BatchTable_aggregate(where: {ownedBy: {_eq: $ownedBy},status:{_eq:"InStock"}}, distinct_on: productId) {
            aggregate {
                count(columns: batch)
            }
        },
        ProductLine: BatchTable(where: {ownedBy: {_eq: $ownedBy},status:{_eq:"InStock"}}, distinct_on: productId) {
            id
            Product{productLineId}
        },
        Inventory: BatchTable_aggregate(where: {ownedBy: {_eq: $ownedBy},status:{_eq:"InStock"}}) {
            aggregate {
                count
            }
        }
    }
`
export const GET_ORG_BY_ID = gql`
    query ($id:uuid!){
        Organizations(where:{status:{_eq: "Active"},id:{_eq:$id}}){
            id
            partnerType
            PartnerType {id name color prefix }
            ParentPartner{id name mobile email partnerCode}
            PreferedVP{id name mobile email partnerCode}
            SalesPersons {id SalesPerson{name mobile email id}}
            PreferredDistributors {id prefferedDistributorId PrefferedPartner{id name mobile email partnerCode}}
            name
            status
            address
            mobile
            alternateNumber
            email
            PAN
            gstin
            aadhaarNumber
            incorporateDate
            partnerCode
            bankDetails
            products
            referralCode
            parentPartnerId
            createdOn
            documents
        }
        Users(where:{orgId:{_eq:$id}}){
            id
            mobile
            email
            birthdate
            aniversary
            name
            userTypeId
            UserType{id name}
            profile
        }
    }
`

export const VERIFY_ORG_BY_AGREEMENT_KEY = gql`
    query ($id:uuid!){
        Organizations(where:{status:{_eq: "Active"},id:{_eq:$id}}){
            id
            isAggrementAccepted
        }
    }
`
export const GET_ORG_NAME_BY_ID = gql`
    query ($id:uuid!){
        Organizations(where:{status:{_eq: "Active"},id:{_eq:$id}}){
            name
        }
    }
`
export const GET_ALL_ORGANIZATIONS_COUNT = gql`
    query ($partnerType:[uuid!],$prefferedVP:uuid!){
        Organizations(where:{status:{_eq: "Active"},partnerType:{_nin:$partnerType},
            PreferredDistributors: {prefferedDistributorId: {_eq: $prefferedVP}}}){
            partnerType
        }
    }
`
